import { render, staticRenderFns } from "./InternalRequestsByModuleReportDetail.vue?vue&type=template&id=1331936d&scoped=true&"
import script from "./InternalRequestsByModuleReportDetail.vue?vue&type=script&lang=js&"
export * from "./InternalRequestsByModuleReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331936d",
  null
  
)

export default component.exports